export interface OidcBootstrapConfig {
  clientId: string;
  authHost: string;
  authorizeUrl: string;
  redirectUri: string;
  scope: string;
}

export function buildAuthorizeUrl(
  config: OidcBootstrapConfig,
  codeChallenge: string,
  state: string
): string {
  const url = new URL(config.authorizeUrl || `${config.authHost}/auth/authorize`);
  url.searchParams.set('client_id', config.clientId);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('redirect_uri', config.redirectUri);
  url.searchParams.set('scope', config.scope);
  url.searchParams.set('code_challenge', codeChallenge);
  url.searchParams.set('code_challenge_method', 'S256');
  url.searchParams.set('state', state);
  url.searchParams.set('display', 'popup');
  return url.toString();
}
